// extracted by mini-css-extract-plugin
module.exports = {"chart-container":"StockHoldersOverTimeChart_chart-container__fo_RG"};